import ENVIRONMENT from '@/environment';

export const integrationsStepPath = (stepId: string): string => {
  return `${ENVIRONMENT.BITRISE_WEBSITE_LANDING_ROOT_URL}/integrations/steps/${stepId}`;
};
